import { RecipeIcon } from "../../assets";
import styles from "./styles.module.scss";

type FoodImageProps = {
  image?: string;
  isGrayed?: boolean;
};

const FoodImage: React.FC<FoodImageProps> = ({ image, isGrayed }) => {
  return (
    <div className={styles.wrapper}>
      {image ? (
        <img
          src={image}
          alt="food"
          style={isGrayed ? { filter: "grayscale(100%)" } : {}}
        />
      ) : (
        <RecipeIcon />
      )}
    </div>
  );
};

export default FoodImage;
